import { apiPatch, apiPost } from "./apiClient";
import { publishSourcingChange } from "../suppliers/supplierRecommendationsModel";

// Same PATCH route, reused for 5 distinct field-edit purposes across two
// domains: inline part-field edits/disable/enable in WorkflowTaskDrawer, and
// quote-selection/selling-price edits in PriceUpdateDrawer. Each domain's
// own model layer wraps this primitive with its specific payload shape.
export function patchQueryPart(partId, fields) {
  return apiPatch(`/query-parts/${partId}`, fields).then(res => {
    if (res.data?.success !== true) {
      const error = new Error(res.data?.message || "Failed to update part");
      error.response = res;
      throw error;
    }
    if (res.data?.success && ["uzdpart360_part_id", "part_id", "canonical_part_id", "part_name", "part_number", "side", "condition_preference", "status"].some(key => Object.prototype.hasOwnProperty.call(fields, key))) publishSourcingChange();
    return res.data;
  });
}

export function addQueryPart(payload) {
  return apiPost("/query-parts", payload).then(res => { if (res.data?.success) publishSourcingChange({ queryPk: payload.query_pk }); return res.data; });
}
